import { generatePath, useParams } from 'react-router-dom';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { useAlert, AlertType } from 'src/components/AlertsProvider';
import { useForm } from 'src/components/Form';
import { solutionUserEditFormFields } from '../formFields';
import { SolutionType, SolutionUserItem } from '../../types';
import { API_SOLUTION_USERS } from '../../constants';
import { useSolutionAssignSiteOptions, useSolutionGroups } from '../../redux';

type Props = {
  item: SolutionUserItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
};

function SolutionUsersEditModal({ item, open, onClose }: Props) {
  const { showAlert } = useAlert();
  const { solutionId, solutionType } = useParams();
  const [options, optionsLoading] = useSolutionAssignSiteOptions();
  const [data, dataLoading] = useSolutionGroups();
  const dataOptions = data?.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Put,
        url: generatePath(API_SOLUTION_USERS, { solutionId }),
        params: {
          ...params,
          PhoneNumber: params.mobileNumber
            ? params.countryCode + params.mobileNumber
            : '',
          groupIds: params.groupIds || [],
          siteIds:
            solutionType === SolutionType.Industrial ? params.siteIds : [],
        },
      }),
    () => {
      showAlert({
        type: AlertType.Success,
        title: 'Solutions user updated',
        text: 'Solutions user has been successfully updated.',
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  const [form, handleSubmit] = useForm({
    fields: solutionUserEditFormFields(
      solutionType,
      options,
      optionsLoading,
      dataOptions,
      dataLoading,
      item?.groupIds,
      item?.siteIds
    ),
    values: item,
    sx: containerStyle,
    onSubmit,
  });

  return (
    <ModalDialog
      open={open}
      title={`Edit user: ${item?.userId}`}
      loading={loading}
      onClose={onClose}
      onConfirm={handleSubmit}
      confirmBtnText="Save"
      maxWidth="sm"
    >
      {form}
    </ModalDialog>
  );
}

export default SolutionUsersEditModal;
